<template>
<div class="guest">
  <form class="box login-form">
    <h3 class="title is-3 has-text-centered">Sign In</h3>
    <div class="columns">
      <div class="column">
        <email-input 
          required
          label="Email" 
          store="auth"/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <password-input 
          required
          field="password"
          mutation="updatePassword"
          label="Password" 
          store="auth"/>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <a href="">Forgot your password?</a>
      </div>
      <div class="column is-narrow">
        <submit-button 
          right-icon="arrow-right"
          :working="authenticating" 
          @submit="authenticate">
          Sign In
        </submit-button>
      </div>
    </div>
  </form>
</div>  
</template>
<script>
import EmailInput from '@/layout/forms/user/EmailInput'
import PasswordInput from '@/layout/forms/user/PasswordInput'

export default {

  components: {
    EmailInput,
    PasswordInput
  },

  data: () => ({
    authenticating: false
  }),

  methods: {
    authenticate() {
      this.$store.dispatch('auth/authenticate').then(() => {
        this.$router.push({ name: 'dashboard' })
      }).catch(error => {
       
      })
    }
  }
  
}
</script>